import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { commandFailed } from '../components/store/slices/commandFailureSlice';
import { sendCommand } from '../services/sendCommand.service';

export const useReportCommandFailure = (system, deviceMac, deviceName) => {
  const dispatch = useDispatch();

  return useCallback(
    (error) =>
      dispatch(
        commandFailed({
          system,
          device: deviceName || deviceMac,
          macs: [deviceMac],
          error,
        }),
      ),
    [dispatch, system, deviceMac, deviceName],
  );
};

export const useDeviceCommand = (system, deviceMac, deviceName) => {
  const reportFailure = useReportCommandFailure(system, deviceMac, deviceName);
  const { mutate } = useMutation(
    (data) => sendCommand(system, deviceMac, data),
    { onError: (error) => reportFailure(error) },
  );

  return mutate;
};
